module.exports = __webpack_public_path__ + "img/obby_2.2a616e8e.png";